// eslint-disable-next-line import/prefer-default-export
export function calculateUpfront(reduxState) {
  const { planSelected, voucher } = reduxState.checkoutReducer

  return (voucher ? 0 : planSelected.rate)
}



// WEBPACK FOOTER //
// ./containers/stages/PaymentStage/utils.js